<template>
  <div>
    <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
      <b-breadcrumb-item tag="a" @click.prevent="$router.push({name: 'secret-list'})">
        {{ $t('secrets.title') }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ $t('secrets.addNew') }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <div class="box">
      <SecretForm ref="secretForm" @saved="onSaved" @valid="v => (canSave = v)" />
      <div class="mt-3">
        <b-button type="is-primary" :disabled="!canSave" @click="triggerSave">{{ $t('global.save') }}</b-button>
        <b-button class="ml-2" @click="$router.back()">{{ $t('global.back') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, getCurrentInstance, ref } from 'vue'
import SecretForm from '@/components/SecretForm.vue'

export default defineComponent({
  name: 'SecretAdd',
  components: { SecretForm },
  setup() {
    const vm = getCurrentInstance()
    const canSave = ref(false)
    const secretForm = ref<any>(null)
    const triggerSave = () => secretForm.value?.submit?.()
    const onSaved = () => { vm?.proxy?.$router.push({ name: 'secret-list' }) }
    return { onSaved, canSave, triggerSave, secretForm }
  }
})
</script>


